module.exports = __webpack_public_path__ + "img/pakistan.36d95086.svg";